// ** Root Slice & Helper Functions
import { baseApi, customErrorHandler, TAGS } from '@/shared/api'

// ** Type Imports
import { type EnterpriseFormVariables } from '../model/types'

const subscriptionApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		generateStripeCheckoutSessionUrl: build.mutation<any, any>({
			query: () => ({
				url: `subscriptions/subscription-session`,
				method: 'GET'
			}),
			transformErrorResponse: customErrorHandler
		}),
		finishSubscription: build.mutation<
			{ success: boolean; message: string },
			{ sessionId: string }
		>({
			query: ({ sessionId }) => ({
				url: `subscriptions/finish-subscription?sessionId=${sessionId}`,
				method: 'PUT'
			}),
			transformErrorResponse: customErrorHandler,
			invalidatesTags: [TAGS.ME]
		}),
		sendEmailForCustomPlan: build.mutation<
			{ success: boolean; message: string },
			EnterpriseFormVariables
		>({
			query: (data) => ({
				url: `subscriptions`,
				method: 'POST',
				body: data
			}),
			transformErrorResponse: customErrorHandler
		}),
		generateStripeCustomerPortalUrl: build.mutation<any, any>({
			query: () => ({
				url: `subscriptions/customer-portal-session`,
				method: 'GET'
			}),
			transformErrorResponse: customErrorHandler
		}),
		getClientCount: build.query<any, { organizationId: number | undefined }>({
			query: ({ organizationId }) => ({
				url: `clients/client-count-for-organization`,
				method: 'GET',
				params: { organizationId }
			}),
			providesTags: [TAGS.CLIENT_COUNT],
			transformErrorResponse: customErrorHandler
		}),
		skipActiveTrial: build.mutation<{ success: boolean; message: string }, any>(
			{
				query: () => ({
					url: `subscriptions/skip-active-trail`,
					method: 'POST'
				}),
				transformErrorResponse: customErrorHandler
			}
		)
	})
})

export const {
	useGenerateStripeCheckoutSessionUrlMutation,
	useFinishSubscriptionMutation,
	useSendEmailForCustomPlanMutation,
	useGenerateStripeCustomerPortalUrlMutation,
	useGetClientCountQuery,
	useSkipActiveTrialMutation
} = subscriptionApi
